import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'forceCancelOrderDialog.title',
    defaultMessage: 'Force cancel order',
    description: 'Force cancel order dialog title',
  },
  description: {
    id: 'forceCancelOrderDialog.description',
    defaultMessage: 'Are you sure you would like to force cancel this order?',
    description: 'Description force cancel order dialog without warnings',
  },
  warningDescription: {
    id: 'forceCancelOrderDialog.warningDescription',
    defaultMessage:
      'Are you sure you would like to force cancel this order? This can have effect on the following:',
    description: 'Warning description force cancel order dialog',
  },
  warnings: {
    transportsShipped: {
      id: 'forceCancelOrderDialog.warnings.transportsShipped',
      defaultMessage: 'Transports for this order may already be shipped to an (un)managed location',
      description: 'Transports shipped warning',
    },
  },
  actions: {
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'Force cancel order dialog cancel button label',
    },
    continue: {
      id: 'actions.continue',
      defaultMessage: 'Continue',
      description: 'Force cancel order dialog continue button label',
    },
  },
};

export default defineMessages(translations);
